import { p as proxyCustomElement, H, d as createEvent, h } from './p-23afa4c1.js';
import { t as tippy } from './p-5b08239b.js';
import { F as FormField } from './p-f70fad97.js';
import { d as getAriaExpanded, c as getAriaDisabled, b as getAriaRequired, g as getAriaInvalid, a as getAriaDescribedBy } from './p-55335119.js';
import { d as defineCustomElement$8 } from './p-b53f7d49.js';
import { d as defineCustomElement$7 } from './p-79ac77d0.js';
import { d as defineCustomElement$6 } from './p-5fc761a2.js';
import { d as defineCustomElement$5 } from './p-536c1b8e.js';
import { d as defineCustomElement$4 } from './p-63c51a9c.js';
import { d as defineCustomElement$3 } from './p-5c92007e.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { n as nextTick } from './p-4f3570ee.js';
import { i as isNodeEnvironment } from './p-2f624564.js';
import { g as global } from './p-4ff03e8a.js';
import { t as transformTagName, r as resolveAppearance } from './p-d1ae9dd0.js';

const interceptEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
};
/**
 * Ensure that the focus is consistently reset to the element provided.
 * Repeatedly blurring and focusing the element forces VoiceOver on iOS to
 * regain focus on the element.
 */
const forceFocus = async function (element, retries = 5) {
    element.addEventListener('focus', interceptEvent);
    element.addEventListener('blur', interceptEvent);
    for (let index = 0; index < retries; index++) {
        await nextTick();
        element.blur();
        element.focus();
    }
    element.blur();
    element.removeEventListener('focus', interceptEvent);
    element.removeEventListener('blur', interceptEvent);
    element.focus();
};

var lib$1 = {exports: {}};

var _default$1 = {};

var lib = {exports: {}};

var _default = {};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList$1 () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue$1(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


_default.whiteList = getDefaultWhiteList$1();
_default.getDefaultWhiteList = getDefaultWhiteList$1;
_default.onAttr = onAttr;
_default.onIgnoreAttr = onIgnoreAttr;
_default.safeAttrValue = safeAttrValue$1;

var util$1 = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var _$3 = util$1;


/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle$1 (css, onAttr) {
  css = _$3.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = _$3.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = _$3.trim(source.slice(0, j));
        var value = _$3.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) ; else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return _$3.trim(retCSS);
}

var parser$2 = parseStyle$1;

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT$1 = _default;
var parseStyle = parser$2;


/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull$1 (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject$1 (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS$2 (options) {
  options = shallowCopyObject$1(options || {});
  options.whiteList = options.whiteList || DEFAULT$1.whiteList;
  options.onAttr = options.onAttr || DEFAULT$1.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT$1.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT$1.safeAttrValue;
  this.options = options;
}

FilterCSS$2.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull$1(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull$1(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


var css = FilterCSS$2;

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

(function (module, exports) {
var DEFAULT = _default;
var FilterCSS = css;


/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */
function filterCSS (html, options) {
  var xss = new FilterCSS(options);
  return xss.process(html);
}


// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = FilterCSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];

// 在浏览器端使用
if (typeof window !== 'undefined') {
  window.filterCSS = module.exports;
}
}(lib, lib.exports));

var util = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function (str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  },
};

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS$1 = lib.exports.FilterCSS;
var getDefaultCSSWhiteList = lib.exports.getDefaultWhiteList;
var _$2 = util;

function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src",
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height", "loading"],
    ins: ["datetime"],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width",
    ],
  };
}

var defaultCSSFilter = new FilterCSS$1();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = _$2.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value.substr(0, 11) === "data:image/" ||
        value.substr(0, 6) === "ftp://" ||
        value.substr(0, 2) === "./" ||
        value.substr(0, 3) === "../" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 =
  /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 =
  /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _$2.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function () {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _$2.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function (tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end,
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function (html) {
      var rethtml = "";
      var lastPos = 0;
      _$2.forEach(removeList, function (pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    },
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  var retHtml = "";
  var lastPos = 0;
  while (lastPos < html.length) {
    var i = html.indexOf("<!--", lastPos);
    if (i === -1) {
      retHtml += html.slice(lastPos);
      break;
    }
    retHtml += html.slice(lastPos, i);
    var j = html.indexOf("-->", i);
    if (j === -1) {
      break;
    }
    lastPos = j + 3;
  }
  return retHtml;
}

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function (char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

_default$1.whiteList = getDefaultWhiteList();
_default$1.getDefaultWhiteList = getDefaultWhiteList;
_default$1.onTag = onTag;
_default$1.onIgnoreTag = onIgnoreTag;
_default$1.onTagAttr = onTagAttr;
_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
_default$1.safeAttrValue = safeAttrValue;
_default$1.escapeHtml = escapeHtml;
_default$1.escapeQuote = escapeQuote;
_default$1.unescapeQuote = unescapeQuote;
_default$1.escapeHtmlEntities = escapeHtmlEntities;
_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
_default$1.friendlyAttrValue = friendlyAttrValue;
_default$1.escapeAttrValue = escapeAttrValue;
_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
_default$1.StripTagBody = StripTagBody;
_default$1.stripCommentTag = stripCommentTag;
_default$1.stripBlankChar = stripBlankChar;
_default$1.attributeWrapSign = '"';
_default$1.cssFilter = defaultCSSFilter;
_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;

var parser$1 = {};

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var _$1 = util;

/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = _$1.spaceIndex(html);
  var tagName;
  if (i === -1) {
    tagName = html.slice(1, -1);
  } else {
    tagName = html.slice(1, i + 1);
  }
  tagName = _$1.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag$1(html, onTag, escapeHtml) {

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">" || currentPos === len - 1) {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if (c === '"' || c === "'") {
          var i = 1;
          var ic = html.charAt(currentPos - i);

          while (ic.trim() === "" || ic === "=") {
            if (ic === "=") {
              quoteStart = c;
              continue chariterator;
            }
            ic = html.charAt(currentPos - ++i);
          }
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < len) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr$1(html, onAttr) {

  var lastPos = 0;
  var lastMarkPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = _$1.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastMarkPos
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _$1.trim(html.slice(lastMarkPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_$1.trim(html.slice(lastPos))));
    }
  }

  return _$1.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findNextQuotationMark(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "'" || c === '"') return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

parser$1.parseTag = parseTag$1;
parser$1.parseAttr = parseAttr$1;

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = lib.exports.FilterCSS;
var DEFAULT = _default$1;
var parser = parser$1;
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = util;

/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/",
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = _.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing,
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

function keysToLowerCase(obj) {
  var ret = {};
  for (var i in obj) {
    if (Array.isArray(obj[i])) {
      ret[i.toLowerCase()] = obj[i].map(function (item) {
        return item.toLowerCase();
      });
    } else {
      ret[i.toLowerCase()] = obj[i];
    }
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }
  if (options.whiteList || options.allowList) {
    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
  } else {
    options.whiteList = DEFAULT.whiteList;
  }

  this.attributeWrapSign = options.singleQuotedAttributeValue === true ? "'" : DEFAULT.attributeWrapSign;

  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function (html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var attributeWrapSign = me.attributeWrapSign;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag(
    html,
    function (sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag),
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function (name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '=' + attributeWrapSign + value + attributeWrapSign;
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull(ret)) return ret;
            return;
          }
        });

        // build new tag html
        html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        ret = onIgnoreTag(tag, html, info);
        if (!isNull(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

var xss$1 = FilterXSS;

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

(function (module, exports) {
var DEFAULT = _default$1;
var parser = parser$1;
var FilterXSS = xss$1;

/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */
function filterXSS(html, options) {
  var xss = new FilterXSS(options);
  return xss.process(html);
}

exports = module.exports = filterXSS;
exports.filterXSS = filterXSS;
exports.FilterXSS = FilterXSS;

(function () {
  for (var i in DEFAULT) {
    exports[i] = DEFAULT[i];
  }
  for (var j in parser) {
    exports[j] = parser[j];
  }
})();

// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") {
  window.filterXSS = module.exports;
}

// using `xss` on the WebWorker, output `filterXSS` to the globals
function isWorkerEnv() {
  return (
    typeof self !== "undefined" &&
    typeof DedicatedWorkerGlobalScope !== "undefined" &&
    self instanceof DedicatedWorkerGlobalScope
  );
}
if (isWorkerEnv()) {
  self.filterXSS = module.exports;
}
}(lib$1, lib$1.exports));

const xss = lib$1.exports;

const cosmosWhitelist = {
	"cosmos-avatar": [
	"alt",
	"appearance",
	"framed",
	"loading",
	"name",
	"size",
	"sizes",
	"src",
	"srcset"
],
	"cosmos-badge": [
	"appearance",
	"href",
	"kind",
	"rel",
	"shape",
	"size",
	"target"
],
	"cosmos-button": [
	"appearance",
	"ariaExpanded",
	"ariaHaspopup",
	"ariaLabel",
	"busy",
	"buttonTitle",
	"decorative",
	"disabled",
	"hovered",
	"href",
	"iconPlacement",
	"kind",
	"rel",
	"shape",
	"size",
	"target",
	"type",
	"width"
],
	"cosmos-chip": [
	"appearance",
	"ariaLabel",
	"shape"
],
	"cosmos-flag": [
	"alt",
	"code",
	"loading"
],
	"cosmos-icon-360-photo": [
	"ariaLabel"
],
	"cosmos-icon-360-video": [
	"ariaLabel"
],
	"cosmos-icon-add": [
	"ariaLabel"
],
	"cosmos-icon-airplay": [
	"ariaLabel"
],
	"cosmos-icon-align-center": [
	"ariaLabel"
],
	"cosmos-icon-align-left": [
	"ariaLabel"
],
	"cosmos-icon-align-right": [
	"ariaLabel"
],
	"cosmos-icon-amazon-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-amazon-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-amazon-music-branded": [
	"ariaLabel"
],
	"cosmos-icon-amazon-music": [
	"ariaLabel"
],
	"cosmos-icon-amazon": [
	"ariaLabel"
],
	"cosmos-icon-apple-podcasts-branded": [
	"ariaLabel"
],
	"cosmos-icon-apple-podcasts": [
	"ariaLabel"
],
	"cosmos-icon-apple": [
	"ariaLabel"
],
	"cosmos-icon-ar-active": [
	"ariaLabel"
],
	"cosmos-icon-ar-label": [
	"ariaLabel"
],
	"cosmos-icon-ar-mobile": [
	"ariaLabel"
],
	"cosmos-icon-ar": [
	"ariaLabel"
],
	"cosmos-icon-archive": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-down-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-down-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-up-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-up-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-down-up": [
	"ariaLabel"
],
	"cosmos-icon-arrow-down": [
	"ariaLabel"
],
	"cosmos-icon-arrow-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-return-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-return-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-triangle-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-triangle-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-up": [
	"ariaLabel"
],
	"cosmos-icon-author": [
	"ariaLabel"
],
	"cosmos-icon-back-10": [
	"ariaLabel"
],
	"cosmos-icon-back-15": [
	"ariaLabel"
],
	"cosmos-icon-back-20": [
	"ariaLabel"
],
	"cosmos-icon-back": [
	"ariaLabel"
],
	"cosmos-icon-backward": [
	"ariaLabel"
],
	"cosmos-icon-bandsintown-branded": [
	"ariaLabel"
],
	"cosmos-icon-bandsintown": [
	"ariaLabel"
],
	"cosmos-icon-baseball-cap": [
	"ariaLabel"
],
	"cosmos-icon-bookmark-filled": [
	"ariaLabel"
],
	"cosmos-icon-bookmark": [
	"ariaLabel"
],
	"cosmos-icon-browse-filled": [
	"ariaLabel"
],
	"cosmos-icon-browse": [
	"ariaLabel"
],
	"cosmos-icon-bulb-filled": [
	"ariaLabel"
],
	"cosmos-icon-bulb": [
	"ariaLabel"
],
	"cosmos-icon-buy-tickets": [
	"ariaLabel"
],
	"cosmos-icon-calendar-filled": [
	"ariaLabel"
],
	"cosmos-icon-calendar": [
	"ariaLabel"
],
	"cosmos-icon-can-inverted": [
	"ariaLabel"
],
	"cosmos-icon-can": [
	"ariaLabel"
],
	"cosmos-icon-cancel": [
	"ariaLabel"
],
	"cosmos-icon-captions-filled": [
	"ariaLabel"
],
	"cosmos-icon-captions": [
	"ariaLabel"
],
	"cosmos-icon-caret-down": [
	"ariaLabel"
],
	"cosmos-icon-caret-left": [
	"ariaLabel"
],
	"cosmos-icon-caret-right": [
	"ariaLabel"
],
	"cosmos-icon-caret-up": [
	"ariaLabel"
],
	"cosmos-icon-chat-add": [
	"ariaLabel"
],
	"cosmos-icon-checkbox-checked": [
	"ariaLabel"
],
	"cosmos-icon-checkbox-unchecked": [
	"ariaLabel"
],
	"cosmos-icon-checkmark": [
	"ariaLabel"
],
	"cosmos-icon-checkout": [
	"ariaLabel"
],
	"cosmos-icon-chevron-down": [
	"ariaLabel"
],
	"cosmos-icon-chevron-left": [
	"ariaLabel"
],
	"cosmos-icon-chevron-right": [
	"ariaLabel"
],
	"cosmos-icon-chevron-up": [
	"ariaLabel"
],
	"cosmos-icon-chromecast-filled": [
	"ariaLabel"
],
	"cosmos-icon-chromecast": [
	"ariaLabel"
],
	"cosmos-icon-clear": [
	"ariaLabel"
],
	"cosmos-icon-clip": [
	"ariaLabel"
],
	"cosmos-icon-clock": [
	"ariaLabel"
],
	"cosmos-icon-close-small": [
	"ariaLabel"
],
	"cosmos-icon-close": [
	"ariaLabel"
],
	"cosmos-icon-cloud": [
	"ariaLabel"
],
	"cosmos-icon-code-block": [
	"ariaLabel"
],
	"cosmos-icon-collapse-arrows": [
	"ariaLabel"
],
	"cosmos-icon-collapse-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-collapse-vertical": [
	"ariaLabel"
],
	"cosmos-icon-collapse": [
	"ariaLabel"
],
	"cosmos-icon-columns": [
	"ariaLabel"
],
	"cosmos-icon-comment": [
	"ariaLabel"
],
	"cosmos-icon-contextual": [
	"ariaLabel"
],
	"cosmos-icon-contract": [
	"ariaLabel"
],
	"cosmos-icon-copy-link": [
	"ariaLabel"
],
	"cosmos-icon-country": [
	"ariaLabel"
],
	"cosmos-icon-couple": [
	"ariaLabel"
],
	"cosmos-icon-crashed": [
	"ariaLabel"
],
	"cosmos-icon-create": [
	"ariaLabel"
],
	"cosmos-icon-crew": [
	"ariaLabel"
],
	"cosmos-icon-crop": [
	"ariaLabel"
],
	"cosmos-icon-currency": [
	"ariaLabel"
],
	"cosmos-icon-currently-watching": [
	"ariaLabel"
],
	"cosmos-icon-cut": [
	"ariaLabel"
],
	"cosmos-icon-deezer-branded": [
	"ariaLabel"
],
	"cosmos-icon-deezer": [
	"ariaLabel"
],
	"cosmos-icon-delete": [
	"ariaLabel"
],
	"cosmos-icon-delivery": [
	"ariaLabel"
],
	"cosmos-icon-desktop": [
	"ariaLabel"
],
	"cosmos-icon-devices": [
	"ariaLabel"
],
	"cosmos-icon-directions": [
	"ariaLabel"
],
	"cosmos-icon-discover": [
	"ariaLabel"
],
	"cosmos-icon-document-filled": [
	"ariaLabel"
],
	"cosmos-icon-download": [
	"ariaLabel"
],
	"cosmos-icon-download-error": [
	"ariaLabel"
],
	"cosmos-icon-downloading": [
	"ariaLabel"
],
	"cosmos-icon-drag-handle-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-drink": [
	"ariaLabel"
],
	"cosmos-icon-drag-handle-vertical": [
	"ariaLabel"
],
	"cosmos-icon-duplicate": [
	"ariaLabel"
],
	"cosmos-icon-edit": [
	"ariaLabel"
],
	"cosmos-icon-email": [
	"ariaLabel"
],
	"cosmos-icon-emoji": [
	"ariaLabel"
],
	"cosmos-icon-envelope-filled": [
	"ariaLabel"
],
	"cosmos-icon-enlarge": [
	"ariaLabel"
],
	"cosmos-icon-epg": [
	"ariaLabel"
],
	"cosmos-icon-episode": [
	"ariaLabel"
],
	"cosmos-icon-error-filled": [
	"ariaLabel"
],
	"cosmos-icon-event-details": [
	"ariaLabel"
],
	"cosmos-icon-event-end": [
	"ariaLabel"
],
	"cosmos-icon-event-series": [
	"ariaLabel"
],
	"cosmos-icon-event-start": [
	"ariaLabel"
],
	"cosmos-icon-event": [
	"ariaLabel"
],
	"cosmos-icon-expand-arrows": [
	"ariaLabel"
],
	"cosmos-icon-expand-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-expand-less": [
	"ariaLabel"
],
	"cosmos-icon-expand-more": [
	"ariaLabel"
],
	"cosmos-icon-expand-vertical": [
	"ariaLabel"
],
	"cosmos-icon-expand": [
	"ariaLabel"
],
	"cosmos-icon-external-link": [
	"ariaLabel"
],
	"cosmos-icon-facebook-branded": [
	"ariaLabel"
],
	"cosmos-icon-facebook": [
	"ariaLabel"
],
	"cosmos-icon-fast-checkout": [
	"ariaLabel"
],
	"cosmos-icon-fast-forward": [
	"ariaLabel"
],
	"cosmos-icon-fast-rewind": [
	"ariaLabel"
],
	"cosmos-icon-feedback-filled": [
	"ariaLabel"
],
	"cosmos-icon-feature-film": [
	"ariaLabel"
],
	"cosmos-icon-feedback": [
	"ariaLabel"
],
	"cosmos-icon-female": [
	"ariaLabel"
],
	"cosmos-icon-file-download": [
	"ariaLabel"
],
	"cosmos-icon-file-remove": [
	"ariaLabel"
],
	"cosmos-icon-file-upload": [
	"ariaLabel"
],
	"cosmos-icon-film-camera": [
	"ariaLabel"
],
	"cosmos-icon-films": [
	"ariaLabel"
],
	"cosmos-icon-filter-list": [
	"ariaLabel"
],
	"cosmos-icon-filter-remove": [
	"ariaLabel"
],
	"cosmos-icon-filter": [
	"ariaLabel"
],
	"cosmos-icon-flag": [
	"ariaLabel"
],
	"cosmos-icon-folder-add": [
	"ariaLabel"
],
	"cosmos-icon-folder-download": [
	"ariaLabel"
],
	"cosmos-icon-folder-open": [
	"ariaLabel"
],
	"cosmos-icon-folder-remove": [
	"ariaLabel"
],
	"cosmos-icon-folder-shared": [
	"ariaLabel"
],
	"cosmos-icon-folder-upload": [
	"ariaLabel"
],
	"cosmos-icon-folder": [
	"ariaLabel"
],
	"cosmos-icon-format-bold": [
	"ariaLabel"
],
	"cosmos-icon-format-list-numbered": [
	"ariaLabel"
],
	"cosmos-icon-format-quote": [
	"ariaLabel"
],
	"cosmos-icon-format-size": [
	"ariaLabel"
],
	"cosmos-icon-format-underline": [
	"ariaLabel"
],
	"cosmos-icon-forward-10": [
	"ariaLabel"
],
	"cosmos-icon-forward-20": [
	"ariaLabel"
],
	"cosmos-icon-forward-15": [
	"ariaLabel"
],
	"cosmos-icon-forward": [
	"ariaLabel"
],
	"cosmos-icon-fullscreen-exit": [
	"ariaLabel"
],
	"cosmos-icon-funnel-remove": [
	"ariaLabel"
],
	"cosmos-icon-fullscreen": [
	"ariaLabel"
],
	"cosmos-icon-funnel": [
	"ariaLabel"
],
	"cosmos-icon-gallery": [
	"ariaLabel"
],
	"cosmos-icon-game": [
	"ariaLabel"
],
	"cosmos-icon-generic-content": [
	"ariaLabel"
],
	"cosmos-icon-google-branded": [
	"ariaLabel"
],
	"cosmos-icon-globe-geo": [
	"ariaLabel"
],
	"cosmos-icon-google-play": [
	"ariaLabel"
],
	"cosmos-icon-google-play-branded": [
	"ariaLabel"
],
	"cosmos-icon-google-podcasts": [
	"ariaLabel"
],
	"cosmos-icon-google-podcasts-branded": [
	"ariaLabel"
],
	"cosmos-icon-google": [
	"ariaLabel"
],
	"cosmos-icon-grid-layout": [
	"ariaLabel"
],
	"cosmos-icon-grid-live": [
	"ariaLabel"
],
	"cosmos-icon-grid": [
	"ariaLabel"
],
	"cosmos-icon-headphones": [
	"ariaLabel"
],
	"cosmos-icon-headline": [
	"ariaLabel"
],
	"cosmos-icon-heart-filled": [
	"ariaLabel"
],
	"cosmos-icon-heart": [
	"ariaLabel"
],
	"cosmos-icon-highlights": [
	"ariaLabel"
],
	"cosmos-icon-history": [
	"ariaLabel"
],
	"cosmos-icon-home-filled": [
	"ariaLabel"
],
	"cosmos-icon-home": [
	"ariaLabel"
],
	"cosmos-icon-hot": [
	"ariaLabel"
],
	"cosmos-icon-hourglass-empty": [
	"ariaLabel"
],
	"cosmos-icon-hourglass-full": [
	"ariaLabel"
],
	"cosmos-icon-image-gallery": [
	"ariaLabel"
],
	"cosmos-icon-image": [
	"ariaLabel"
],
	"cosmos-icon-image-in-picture": [
	"ariaLabel"
],
	"cosmos-icon-in-progress": [
	"ariaLabel"
],
	"cosmos-icon-info-filled": [
	"ariaLabel"
],
	"cosmos-icon-info-heat-analyser": [
	"ariaLabel"
],
	"cosmos-icon-info-multicolored": [
	"ariaLabel"
],
	"cosmos-icon-info": [
	"ariaLabel"
],
	"cosmos-icon-infographic": [
	"ariaLabel"
],
	"cosmos-icon-instagram-branded": [
	"ariaLabel"
],
	"cosmos-icon-instagram": [
	"ariaLabel"
],
	"cosmos-icon-interview": [
	"ariaLabel"
],
	"cosmos-icon-invoice": [
	"ariaLabel"
],
	"cosmos-icon-italic": [
	"ariaLabel"
],
	"cosmos-icon-keyboard": [
	"ariaLabel"
],
	"cosmos-icon-label": [
	"ariaLabel"
],
	"cosmos-icon-language": [
	"ariaLabel"
],
	"cosmos-icon-laptop": [
	"ariaLabel"
],
	"cosmos-icon-launch": [
	"ariaLabel"
],
	"cosmos-icon-link": [
	"ariaLabel"
],
	"cosmos-icon-linkedin-branded": [
	"ariaLabel"
],
	"cosmos-icon-linkedin-logo": [
	"ariaLabel"
],
	"cosmos-icon-linkedin": [
	"ariaLabel"
],
	"cosmos-icon-live-broadcast": [
	"ariaLabel"
],
	"cosmos-icon-list": [
	"ariaLabel"
],
	"cosmos-icon-live": [
	"ariaLabel"
],
	"cosmos-icon-loading": [
	"ariaLabel"
],
	"cosmos-icon-location": [
	"ariaLabel"
],
	"cosmos-icon-lock-filled": [
	"ariaLabel"
],
	"cosmos-icon-magic-wand": [
	"ariaLabel"
],
	"cosmos-icon-lock-open": [
	"ariaLabel"
],
	"cosmos-icon-male": [
	"ariaLabel"
],
	"cosmos-icon-map": [
	"ariaLabel"
],
	"cosmos-icon-menu-notification": [
	"ariaLabel"
],
	"cosmos-icon-megaphone": [
	"ariaLabel"
],
	"cosmos-icon-menu-pulsating": [
	"ariaLabel"
],
	"cosmos-icon-menu": [
	"ariaLabel"
],
	"cosmos-icon-messenger-branded": [
	"ariaLabel"
],
	"cosmos-icon-minus": [
	"ariaLabel"
],
	"cosmos-icon-document-filing-2": [
	"ariaLabel"
],
	"cosmos-icon-mixer": [
	"ariaLabel"
],
	"cosmos-icon-mode-dark": [
	"ariaLabel"
],
	"cosmos-icon-mode-light": [
	"ariaLabel"
],
	"cosmos-icon-more": [
	"ariaLabel"
],
	"cosmos-icon-mountain": [
	"ariaLabel"
],
	"cosmos-icon-mouse": [
	"ariaLabel"
],
	"cosmos-icon-multi-language": [
	"ariaLabel"
],
	"cosmos-icon-mute": [
	"ariaLabel"
],
	"cosmos-icon-my-location": [
	"ariaLabel"
],
	"cosmos-icon-news": [
	"ariaLabel"
],
	"cosmos-icon-no-connection": [
	"ariaLabel"
],
	"cosmos-icon-no-data": [
	"ariaLabel"
],
	"cosmos-icon-pagination-filled": [
	"ariaLabel"
],
	"cosmos-icon-pagination": [
	"ariaLabel"
],
	"cosmos-icon-partner-profile": [
	"ariaLabel"
],
	"cosmos-icon-parcel": [
	"ariaLabel"
],
	"cosmos-icon-paste": [
	"ariaLabel"
],
	"cosmos-icon-pause": [
	"ariaLabel"
],
	"cosmos-icon-pen": [
	"ariaLabel"
],
	"cosmos-icon-payment": [
	"ariaLabel"
],
	"cosmos-icon-person-following": [
	"ariaLabel"
],
	"cosmos-icon-person-follow": [
	"ariaLabel"
],
	"cosmos-icon-person-profile-filled": [
	"ariaLabel"
],
	"cosmos-icon-phone": [
	"ariaLabel"
],
	"cosmos-icon-photo-camera-reverse": [
	"ariaLabel"
],
	"cosmos-icon-photo-camera": [
	"ariaLabel"
],
	"cosmos-icon-pie-outline": [
	"ariaLabel"
],
	"cosmos-icon-picture-in-picture": [
	"ariaLabel"
],
	"cosmos-icon-pinterest": [
	"ariaLabel"
],
	"cosmos-icon-pinterest-branded": [
	"ariaLabel"
],
	"cosmos-icon-play": [
	"ariaLabel"
],
	"cosmos-icon-playlist-personalised": [
	"ariaLabel"
],
	"cosmos-icon-playlist": [
	"ariaLabel"
],
	"cosmos-icon-plus": [
	"ariaLabel"
],
	"cosmos-icon-podcast": [
	"ariaLabel"
],
	"cosmos-icon-presentation": [
	"ariaLabel"
],
	"cosmos-icon-preview-filled": [
	"ariaLabel"
],
	"cosmos-icon-preview-off-filled": [
	"ariaLabel"
],
	"cosmos-icon-preview-off": [
	"ariaLabel"
],
	"cosmos-icon-preview": [
	"ariaLabel"
],
	"cosmos-icon-printer": [
	"ariaLabel"
],
	"cosmos-icon-product-placement": [
	"ariaLabel"
],
	"cosmos-icon-push-pin": [
	"ariaLabel"
],
	"cosmos-icon-quality": [
	"ariaLabel"
],
	"cosmos-icon-quiz": [
	"ariaLabel"
],
	"cosmos-icon-radio-button": [
	"ariaLabel"
],
	"cosmos-icon-reddit-branded": [
	"ariaLabel"
],
	"cosmos-icon-reddit": [
	"ariaLabel"
],
	"cosmos-icon-redeem": [
	"ariaLabel"
],
	"cosmos-icon-redo": [
	"ariaLabel"
],
	"cosmos-icon-reload": [
	"ariaLabel"
],
	"cosmos-icon-related-content": [
	"ariaLabel"
],
	"cosmos-icon-reminder-false": [
	"ariaLabel"
],
	"cosmos-icon-reminder-true": [
	"ariaLabel"
],
	"cosmos-icon-remove": [
	"ariaLabel"
],
	"cosmos-icon-rendition": [
	"ariaLabel"
],
	"cosmos-icon-replay-30": [
	"ariaLabel"
],
	"cosmos-icon-replay-5": [
	"ariaLabel"
],
	"cosmos-icon-replay": [
	"ariaLabel"
],
	"cosmos-icon-report": [
	"ariaLabel"
],
	"cosmos-icon-results": [
	"ariaLabel"
],
	"cosmos-icon-roku-replay": [
	"ariaLabel"
],
	"cosmos-icon-ruler": [
	"ariaLabel"
],
	"cosmos-icon-route": [
	"ariaLabel"
],
	"cosmos-icon-rules": [
	"ariaLabel"
],
	"cosmos-icon-save-false": [
	"ariaLabel"
],
	"cosmos-icon-save-true": [
	"ariaLabel"
],
	"cosmos-icon-save": [
	"ariaLabel"
],
	"cosmos-icon-screen-rotation": [
	"ariaLabel"
],
	"cosmos-icon-search": [
	"ariaLabel"
],
	"cosmos-icon-season": [
	"ariaLabel"
],
	"cosmos-icon-section": [
	"ariaLabel"
],
	"cosmos-icon-select-all": [
	"ariaLabel"
],
	"cosmos-icon-secure": [
	"ariaLabel"
],
	"cosmos-icon-select": [
	"ariaLabel"
],
	"cosmos-icon-send": [
	"ariaLabel"
],
	"cosmos-icon-settings": [
	"ariaLabel"
],
	"cosmos-icon-share-facebook": [
	"ariaLabel"
],
	"cosmos-icon-share-messenger": [
	"ariaLabel"
],
	"cosmos-icon-share-reddit": [
	"ariaLabel"
],
	"cosmos-icon-share-tab": [
	"ariaLabel"
],
	"cosmos-icon-share-twitter-filled": [
	"ariaLabel"
],
	"cosmos-icon-share": [
	"ariaLabel"
],
	"cosmos-icon-share-vk": [
	"ariaLabel"
],
	"cosmos-icon-shop": [
	"ariaLabel"
],
	"cosmos-icon-shopping-bag": [
	"ariaLabel"
],
	"cosmos-icon-show": [
	"ariaLabel"
],
	"cosmos-icon-share-whatsapp": [
	"ariaLabel"
],
	"cosmos-icon-sidebar-off": [
	"ariaLabel"
],
	"cosmos-icon-sidebar-on": [
	"ariaLabel"
],
	"cosmos-icon-sign-in": [
	"ariaLabel"
],
	"cosmos-icon-sign-out": [
	"ariaLabel"
],
	"cosmos-icon-size-contract": [
	"ariaLabel"
],
	"cosmos-icon-sign-up": [
	"ariaLabel"
],
	"cosmos-icon-size-expand": [
	"ariaLabel"
],
	"cosmos-icon-skip-next-triangle": [
	"ariaLabel"
],
	"cosmos-icon-skip-next": [
	"ariaLabel"
],
	"cosmos-icon-skip-previous-triangle": [
	"ariaLabel"
],
	"cosmos-icon-skip-previous": [
	"ariaLabel"
],
	"cosmos-icon-snapchat-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-snapchat": [
	"ariaLabel"
],
	"cosmos-icon-snapchat-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-sneaker": [
	"ariaLabel"
],
	"cosmos-icon-songkick-branded": [
	"ariaLabel"
],
	"cosmos-icon-songkick": [
	"ariaLabel"
],
	"cosmos-icon-sort-a-z": [
	"ariaLabel"
],
	"cosmos-icon-sort-z-a": [
	"ariaLabel"
],
	"cosmos-icon-sort": [
	"ariaLabel"
],
	"cosmos-icon-soundcloud-branded": [
	"ariaLabel"
],
	"cosmos-icon-soundcloud": [
	"ariaLabel"
],
	"cosmos-icon-spotify": [
	"ariaLabel"
],
	"cosmos-icon-spotify-branded": [
	"ariaLabel"
],
	"cosmos-icon-star-filled": [
	"ariaLabel"
],
	"cosmos-icon-star": [
	"ariaLabel"
],
	"cosmos-icon-starred": [
	"ariaLabel"
],
	"cosmos-icon-starred-filled": [
	"ariaLabel"
],
	"cosmos-icon-start": [
	"ariaLabel"
],
	"cosmos-icon-stop": [
	"ariaLabel"
],
	"cosmos-icon-strava-branded": [
	"ariaLabel"
],
	"cosmos-icon-story": [
	"ariaLabel"
],
	"cosmos-icon-strava": [
	"ariaLabel"
],
	"cosmos-icon-submit": [
	"ariaLabel"
],
	"cosmos-icon-subtitles-filled": [
	"ariaLabel"
],
	"cosmos-icon-subtitles": [
	"ariaLabel"
],
	"cosmos-icon-success": [
	"ariaLabel"
],
	"cosmos-icon-t-shirt": [
	"ariaLabel"
],
	"cosmos-icon-tablet": [
	"ariaLabel"
],
	"cosmos-icon-tap": [
	"ariaLabel"
],
	"cosmos-icon-table": [
	"ariaLabel"
],
	"cosmos-icon-team": [
	"ariaLabel"
],
	"cosmos-icon-text-format": [
	"ariaLabel"
],
	"cosmos-icon-thumbs-down": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-thumbs-up": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-dark": [
	"ariaLabel"
],
	"cosmos-icon-tiktok": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-light": [
	"ariaLabel"
],
	"cosmos-icon-translate-alt": [
	"ariaLabel"
],
	"cosmos-icon-trailer": [
	"ariaLabel"
],
	"cosmos-icon-trending": [
	"ariaLabel"
],
	"cosmos-icon-translate": [
	"ariaLabel"
],
	"cosmos-icon-trophy": [
	"ariaLabel"
],
	"cosmos-icon-tv": [
	"ariaLabel"
],
	"cosmos-icon-twitch": [
	"ariaLabel"
],
	"cosmos-icon-twitch-branded": [
	"ariaLabel"
],
	"cosmos-icon-undo": [
	"ariaLabel"
],
	"cosmos-icon-upload": [
	"ariaLabel"
],
	"cosmos-icon-user-settings": [
	"ariaLabel"
],
	"cosmos-icon-user-filled": [
	"ariaLabel"
],
	"cosmos-icon-verified": [
	"ariaLabel"
],
	"cosmos-icon-user": [
	"ariaLabel"
],
	"cosmos-icon-video": [
	"ariaLabel"
],
	"cosmos-icon-view-more": [
	"ariaLabel"
],
	"cosmos-icon-vimeo-branded": [
	"ariaLabel"
],
	"cosmos-icon-vimeo": [
	"ariaLabel"
],
	"cosmos-icon-vine": [
	"ariaLabel"
],
	"cosmos-icon-vk-branded": [
	"ariaLabel"
],
	"cosmos-icon-volume-down": [
	"ariaLabel"
],
	"cosmos-icon-vk": [
	"ariaLabel"
],
	"cosmos-icon-volume-mid": [
	"ariaLabel"
],
	"cosmos-icon-volume-low": [
	"ariaLabel"
],
	"cosmos-icon-volume-up": [
	"ariaLabel"
],
	"cosmos-icon-volume": [
	"ariaLabel"
],
	"cosmos-icon-vr": [
	"ariaLabel"
],
	"cosmos-icon-warehouse": [
	"ariaLabel"
],
	"cosmos-icon-warning": [
	"ariaLabel"
],
	"cosmos-icon-washout": [
	"ariaLabel"
],
	"cosmos-icon-vote": [
	"ariaLabel"
],
	"cosmos-icon-watch": [
	"ariaLabel"
],
	"cosmos-icon-weather": [
	"ariaLabel"
],
	"cosmos-icon-whatsapp-branded": [
	"ariaLabel"
],
	"cosmos-icon-whatsapp": [
	"ariaLabel"
],
	"cosmos-icon-x-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-x-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-x": [
	"ariaLabel"
],
	"cosmos-icon-youtube-branded": [
	"ariaLabel"
],
	"cosmos-icon-youtube": [
	"ariaLabel"
],
	"cosmos-icon-zoom-in": [
	"ariaLabel"
],
	"cosmos-icon-zoom-out": [
	"ariaLabel"
],
	"cosmos-icon": [
	"ariaLabel"
],
	"cosmos-image": [
	"appearance",
	"fit",
	"image",
	"imageAlt",
	"imagePreview",
	"loading",
	"observeResize",
	"radius",
	"sizes",
	"srcset"
],
	"cosmos-link": [
	"href",
	"kind",
	"rel",
	"target"
],
	"cosmos-media-preview": [
	"active",
	"appearance",
	"image",
	"imageAlt",
	"imagePreview",
	"loading",
	"observeResize",
	"playVideo",
	"radius",
	"sizes",
	"srcset",
	"video"
],
	"cosmos-mode": [
	"mode"
],
	"cosmos-spinner": [
	"appearance"
],
	"cosmos-text": [
	"appearance",
	"clamp",
	"kind",
	"size",
	"spacing",
	"tag",
	"weight"
],
	"cosmos-textarea": [
	"appearance",
	"autofocus",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"maxlength",
	"minlength",
	"name",
	"optionalLabel",
	"placeholder",
	"readonly",
	"required",
	"requiredLabel",
	"resizable",
	"rows",
	"validationMessage",
	"value"
],
	"cosmos-title": [
	"appearance",
	"clamp",
	"size",
	"spacing",
	"tag",
	"weight"
],
	"cosmos-tooltip": [
	"appearance",
	"content",
	"controlled",
	"follow",
	"offset",
	"placement",
	"spacing",
	"unreachable",
	"visible"
],
	"deprecated-component": [
	"deprecatedPropValue",
	"newProp",
	"obsoleteProp",
	"replacedProp",
	"updatedPropValue"
],
	"cosmos-link-item": [
	"additionalInfo",
	"appearance",
	"headline",
	"href",
	"image",
	"rel",
	"size",
	"target"
],
	"cosmos-default-item": [
	"appearance",
	"headline",
	"href",
	"metaTextPrimary",
	"metaTextPrimaryClamp",
	"metaTextSecondary",
	"metaTextSecondaryClamp",
	"rel",
	"size",
	"target"
],
	"cosmos-person-item": [
	"additionalInfo",
	"appearance",
	"discipline",
	"external",
	"href",
	"name",
	"nationality",
	"profileImage",
	"profileImageFramed",
	"rel",
	"size",
	"target"
],
	"cosmos-product-item": [
	"additionalInfo",
	"appearance",
	"href",
	"image",
	"name",
	"rel",
	"size",
	"target",
	"text"
],
	"cosmos-story-item": [
	"additionalInfo",
	"appearance",
	"headline",
	"href",
	"image",
	"readingTime",
	"rel",
	"size",
	"target"
],
	"cosmos-video-item": [
	"additionalInfo",
	"appearance",
	"duration",
	"headline",
	"href",
	"image",
	"inProgress",
	"inProgressText",
	"live",
	"liveText",
	"rel",
	"size",
	"target"
],
	"cosmos-default-card": [
	"appearance",
	"badge",
	"cover",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"metaText",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-link-card": [
	"appearance",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-person-card": [
	"appearance",
	"disciplines",
	"external",
	"favoritable",
	"favoriteAriaLabel",
	"favoriteButtonLabel",
	"favorited",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"name",
	"nationality",
	"observeMediaResize",
	"profileImage",
	"rel",
	"target",
	"video"
],
	"cosmos-product-card": [
	"appearance",
	"cta",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"name",
	"observeMediaResize",
	"rel",
	"target",
	"text"
],
	"cosmos-story-card": [
	"appearance",
	"badge",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"playVideo",
	"readingTime",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-video-card": [
	"badge",
	"duration",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"live",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-checkbox": [
	"appearance",
	"autofocus",
	"checked",
	"clamp",
	"disabled",
	"helpText",
	"hitArea",
	"invalid",
	"name",
	"optionalLabel",
	"required",
	"requiredLabel",
	"validationMessage",
	"value"
],
	"cosmos-input": [
	"appearance",
	"autocomplete",
	"autofocus",
	"clearable",
	"clearAriaLabel",
	"disabled",
	"helpText",
	"iconPlacement",
	"invalid",
	"label",
	"name",
	"optionalLabel",
	"placeholder",
	"readonly",
	"required",
	"requiredLabel",
	"type",
	"validationMessage",
	"value"
],
	"cosmos-option": [
	"appearance",
	"disabled",
	"selected",
	"value"
],
	"cosmos-optgroup": [
	"appearance",
	"disabled",
	"label"
],
	"cosmos-radio": [
	"appearance",
	"autofocus",
	"checked",
	"clamp",
	"disabled",
	"focusable",
	"hitArea",
	"invalid",
	"name",
	"required",
	"value"
],
	"cosmos-radio-group": [
	"appearance",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"optionalLabel",
	"requiredLabel",
	"validationMessage"
],
	"cosmos-select": [
	"appearance",
	"autofocus",
	"clearable",
	"clearAriaLabel",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"multiple",
	"name",
	"optionalLabel",
	"placeholder",
	"required",
	"requiredLabel",
	"validationMessage",
	"value"
],
	"cosmos-select-value": [
	"multiple"
],
	"cosmos-checkbox-group": [
	"appearance",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"optionalLabel",
	"requiredLabel",
	"validationMessage"
],
	"cosmos-asset-item-base": [
	"appearance",
	"headline",
	"headlineClamp",
	"href",
	"metaTextAdditional",
	"metaTextPrimary",
	"metaTextPrimaryClamp",
	"metaTextSecondary",
	"metaTextSecondaryClamp",
	"rel",
	"size",
	"target"
],
	"cosmos-icon-document-filing": [
	"ariaLabel"
],
	"cosmos-icon-messenger": [
	"ariaLabel"
]
};

const generalWhitelist = {
	
};

const cosmosXSSWhitelist = Object.assign(Object.assign({}, generalWhitelist), cosmosWhitelist);

const cosmosSelectCss = "@charset \"UTF-8\";.cosmos-form-field{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color);--cosmos-text-font-family:var(--cosmos-select-label-font-family);--cosmos-text-font-size:var(--cosmos-select-label-font-size);--cosmos-text-font-style:var(--cosmos-select-label-font-style);--cosmos-text-font-weight:var(--cosmos-select-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-label-line-height);--cosmos-text-text-transform:var(--cosmos-select-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color);--cosmos-text-font-family:var(--cosmos-select-help-text-font-family);--cosmos-text-font-size:var(--cosmos-select-help-text-font-size);--cosmos-text-font-style:var(--cosmos-select-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-select-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-select-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-select-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-select-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-select-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-select-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-select-required-optional-label-text-transform);display:inline-block;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-select-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-select-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-select-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-select-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-select-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-select-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-select-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color, rgba(0, 15, 30, 0.45))}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host{display:block;width:100%}.cosmos-select{position:relative}.cosmos-select__input{--cosmos-text-color:var(--cosmos-select-color);--cosmos-text-font-family:var(--cosmos-select-font-family);--cosmos-text-font-size:var(--cosmos-select-font-size);--cosmos-text-font-style:var(--cosmos-select-font-style);--cosmos-text-font-weight:var(--cosmos-select-font-weight);--cosmos-text-line-height:var(--cosmos-select-line-height, calc(38rem / var(--cosmos-base-font-size, 16)));-ms-flex-align:center;align-items:center;border:solid var(--cosmos-select-border-width, 1px);border-radius:var(--cosmos-select-border-radius, 4px);-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;gap:8px;-ms-flex-pack:justify;justify-content:space-between;letter-spacing:var(--cosmos-select-letter-spacing, normal);max-width:100%;padding:var(--cosmos-select-padding, 0 12px);position:relative;text-transform:var(--cosmos-select-text-transform, none);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.cosmos-select__input--invalid:not(.cosmos-select__input--disabled){border-color:var(--cosmos-select-invalid-color, #E06600);-webkit-box-shadow:inset 0 0 0 1px var(--cosmos-select-invalid-color, #E06600);box-shadow:inset 0 0 0 1px var(--cosmos-select-invalid-color, #E06600)}.cosmos-select__input--appearance-dark{background-color:var(--cosmos-select-background-color, #FFFFFF);border-color:var(--cosmos-select-border-color, rgba(0, 15, 30, 0.45));color:var(--cosmos-select-color, #000F1E)}.cosmos-select__input--appearance-dark.cosmos-select__input--placeholder{--cosmos-text-color:var(--cosmos-select-placeholder-color)}.cosmos-select__input--appearance-dark.cosmos-select__input--disabled{background:rgba(0, 15, 30, 0.05);border-color:transparent;color:var(--cosmos-select-color, rgba(0, 15, 30, 0.45))}.cosmos-select__input--appearance-dark.cosmos-select__input--disabled.cosmos-select__input--placeholder{--cosmos-text-color:custom-select-property(\"color\", $cosmos-color-surface-glass-dark-45)}.cosmos-select__input--appearance-dark:not(.cosmos-select__input--disabled) .cosmos-select__icon{color:var(--cosmos-select-arrow-color, #000F1E)}.cosmos-select__input--appearance-dark:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid){background-color:var(--cosmos-select-background-color-hover, #FFFFFF);border-color:var(--cosmos-select-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-select__input--appearance-dark:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid):not(.cosmos-select__input--placeholder){color:var(--cosmos-select-color-hover, #000F1E)}.cosmos-select__input--appearance-light{background-color:var(--cosmos-select-background-color, rgba(255, 255, 255, 0.05));border-color:var(--cosmos-select-border-color, rgba(255, 255, 255, 0.45));color:var(--cosmos-select-color, #FFFFFF)}.cosmos-select__input--appearance-light.cosmos-select__input--placeholder{--cosmos-text-color:var(--cosmos-select-placeholder-color)}.cosmos-select__input--appearance-light.cosmos-select__input--disabled{background:rgba(255, 255, 255, 0.05);border-color:transparent;color:var(--cosmos-select-color, rgba(255, 255, 255, 0.45))}.cosmos-select__input--appearance-light.cosmos-select__input--disabled.cosmos-select__input--placeholder{--cosmos-text-color:custom-select-property(\"color\", $cosmos-color-surface-glass-light-45)}.cosmos-select__input--appearance-light:not(.cosmos-select__input--disabled) .cosmos-select__icon{color:var(--cosmos-select-arrow-color, #FFFFFF)}.cosmos-select__input--appearance-light:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid){background-color:var(--cosmos-select-background-color-hover, rgba(255, 255, 255, 0.05));border-color:var(--cosmos-select-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-select__input--appearance-light:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid):not(.cosmos-select__input--placeholder){color:var(--cosmos-select-color-hover, #FFFFFF)}.cosmos-select__icon{color:var(--cosmos-select-arrow-color, currentColor);-ms-flex:0 0 auto;flex:0 0 auto}.cosmos-select__combobox{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto;height:calc(38rem / var(--cosmos-base-font-size, 16));overflow:hidden}.cosmos-select__combobox:focus,.cosmos-select__combobox:focus:not(:focus-visible){outline:none}.cosmos-select__combobox~.cosmos-select__focus-ring{display:none;pointer-events:none}.cosmos-select__combobox:focus~.cosmos-select__focus-ring{border-radius:calc(var(--cosmos-select-border-radius, 4px) * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);display:block}.cosmos-select__listbox{background-color:var(--cosmos-select-options-background-color, #FFFFFF);border-radius:var(--cosmos-select-options-border-radius, 4px);-webkit-box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:2px;left:0;max-height:var(--cosmos-select-options-max-height, 320px);overflow:auto;padding:var(--cosmos-select-options-padding, 4px);pointer-events:none;position:absolute;right:0;top:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:hidden;width:100%;z-index:1}.cosmos-select__listbox--appearance-light{background-color:#00162B;border:1px solid rgba(255, 255, 255, 0.45)}.cosmos-select__listbox--open{pointer-events:auto;visibility:visible}.cosmos-select__clearable-button{--cosmos-button-icon-size:calc(10rem / var(--cosmos-base-font-size, 16))}.cosmos-select__clearable-button::part(base){height:calc(18rem / var(--cosmos-base-font-size, 16));min-width:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-select__sr-value{border-width:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.cosmos-select ::slotted([slot=value]){-ms-flex:1 0 auto;flex:1 0 auto;min-width:0;width:100%}";
const CosmosSelectStyle0 = cosmosSelectCss;

const generateClassNames = bem('cosmos-select');
const CosmosSelect$1 = /*@__PURE__*/ proxyCustomElement(class CosmosSelect extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inputchangeEvent = createEvent(this, "inputchange", 6);
        this.inputinvalidEvent = createEvent(this, "inputinvalid", 3);
        // Creates dependency between the select and the select-value component.
        this.dependency = [h("cosmos-select-value", null)];
        this.PAGE_SIZE = 10;
        this.selectActions = {
            CLOSE: 1,
            CLOSE_SELECT: 2,
            FIRST: 3,
            LAST: 4,
            NEXT: 5,
            OPEN: 6,
            PAGE_DOWN: 7,
            PAGE_UP: 8,
            PREV: 9,
            SELECT: 10,
            TYPE: 11,
        };
        this.searchTerm = '';
        this.isNavigatedWithKeyboard = false;
        this.wasSubmitted = false;
        this.selectValueRef = null;
        this.isUpdatingOptions = false;
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({}, cosmosXSSWhitelist), lib$1.exports.whiteList),
            onTagAttr: (tag, name, value) => {
                if (['slot', 'class', 'id'].includes(name)) {
                    return `${name}="${value}"`;
                }
            },
        };
        this.handleFormData = (event) => {
            this.selectedOptions.forEach((option) => {
                if (this.name && !this.disabled) {
                    event.formData.append(this.name, option.value);
                }
            });
        };
        this.handleFormSubmit = (event) => {
            this.wasSubmitted = true;
            if (this.reportValidity()) {
                event.preventDefault();
                this.reannounceValidationMessage();
            }
        };
        this.handleDocumentClick = () => {
            if (this.isListBoxVisible) {
                // Close the listbox without resetting focus
                this.closeListBox(false);
            }
        };
        this.handleListBoxClick = (event) => {
            // make sure the click on the list is not recognized as a click "outside"
            event.preventDefault();
            event.stopImmediatePropagation();
        };
        this.handleSelectClick = (event) => {
            // make sure the click on the select is not recognized as a click "outside"
            event.preventDefault();
            event.stopImmediatePropagation();
            if (this.disabled) {
                return;
            }
            if (this.isListBoxVisible) {
                this.closeListBox();
            }
            else {
                this.openListBox();
                this.activateOption(this.selectedOptions[0]);
                // Ensures the combobox remains keyboard accessible
                forceFocus(this.comboBoxElement);
            }
        };
        this.handleSelectChange = (value) => {
            if (!this.isInvalidStateControlled() && this.wasSubmitted) {
                this.reportValidity();
            }
            this.inputchangeEvent.emit({ value });
        };
        this.handleSelectKeyDown = (event) => {
            this.isNavigatedWithKeyboard = true;
            if (this.disabled) {
                return;
            }
            const action = this.getActionFromCode(event.code, event.key, event.ctrlKey, event.altKey, event.metaKey);
            if (action) {
                if (event.key !== 'Tab') {
                    event.preventDefault();
                }
                switch (action) {
                    case this.selectActions.CLOSE:
                        this.closeListBox();
                        break;
                    case this.selectActions.CLOSE_SELECT:
                        this.selectOption(this.options[this.activeOptionIndex]);
                        if (!this.multiple) {
                            this.closeListBox();
                        }
                        break;
                    case this.selectActions.OPEN:
                        this.openListBox();
                        nextTick().then(() => {
                            this.activateOption(this.selectedOptions[0] || this.options[0]);
                        });
                        break;
                    case this.selectActions.PAGE_UP:
                        this.activateOption(this.options[Math.max(this.activeOptionIndex - this.PAGE_SIZE, 0)]);
                        break;
                    case this.selectActions.PAGE_DOWN:
                        this.activateOption(this.options[Math.min(this.activeOptionIndex + this.PAGE_SIZE, this.options.length - 1)]);
                        break;
                    case this.selectActions.FIRST:
                        this.openListBox();
                        nextTick().then(() => {
                            this.activateOption(this.options[0]);
                        });
                        break;
                    case this.selectActions.LAST:
                        this.openListBox();
                        nextTick().then(() => {
                            this.activateOption(this.options[this.options.length - 1]);
                        });
                        break;
                    case this.selectActions.NEXT:
                        this.activateOption(this.options[Math.min(this.activeOptionIndex + 1, this.options.length - 1)]);
                        break;
                    case this.selectActions.PREV:
                        this.activateOption(this.options[Math.max(this.activeOptionIndex - 1, 0)]);
                        break;
                    case this.selectActions.TYPE:
                        this.openListBox();
                        nextTick().then(() => {
                            this.activateMatchingOption(this.getSearchTerm(event.key));
                        });
                        break;
                }
            }
        };
        this.handleClearableClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.clearSelect();
        };
        this.handleClearableKeyDown = (event) => {
            if (![' ', 'Enter'].includes(event.key)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.clearSelect();
        };
        this.getValidationMessage = () => {
            if (this.validationMessage) {
                return this.validationMessage;
            }
            else {
                if (!isNodeEnvironment() && this.form) {
                    const ghostSelect = global.document.createElement('select');
                    ghostSelect.name = this.name;
                    ghostSelect.required = !!this.required;
                    ghostSelect.style.display = 'none';
                    this.form.appendChild(ghostSelect);
                    const message = ghostSelect.validationMessage;
                    ghostSelect.remove();
                    return message;
                }
            }
        };
        this.reannounceValidationMessage = async () => {
            if (this.validationMessageRef) {
                // Reset validation message to trigger re-announcement of the live region by screen readers
                // The aria-label is updated instead of the text content to avoid a visual flash
                this.validationMessageRef.ariaLabel = '';
                await nextTick();
                this.validationMessageRef.ariaLabel = this.getValidationMessage();
            }
        };
        this.getPreSelectedOption = () => {
            return this.options.find((option) => option.value === this.value || option.selected);
        };
        this.getPreSelectedOptions = () => {
            return this.options.filter((option) => Array.isArray(this.value) ? this.value.includes(option.value) : option.selected);
        };
        this.clearSelectValueRef = () => {
            if (this.selectValueRef) {
                this.selectValueRef.remove();
                this.selectValueRef = null;
            }
        };
        this.updateSelectValueSlot = () => {
            this.clearSelectValueRef();
            if (!this.multiple && this.selectedOptions.length === 1) {
                this.selectValueRef = global.document.createElement(transformTagName('cosmos-select-value'));
                this.selectValueRef.setAttribute('slot', 'value');
                this.selectValueRef.innerHTML = xss(this.selectedOptions[0].innerHTML, this.xssOptions);
            }
            if (this.multiple && this.selectedOptions.length > 0) {
                this.selectValueRef = global.document.createElement(transformTagName('cosmos-text'));
                this.selectValueRef.setAttribute('slot', 'value');
                this.selectValueRef.setAttribute('size', 'small');
                this.selectValueRef.setAttribute('clamp', '1');
                this.selectedOptions.forEach((option, index) => {
                    var _a, _b;
                    const selectValue = global.document.createElement(transformTagName('cosmos-select-value'));
                    selectValue.setAttribute('multiple', 'true');
                    selectValue.innerHTML = xss(option.innerHTML, this.xssOptions);
                    (_a = this.selectValueRef) === null || _a === void 0 ? void 0 : _a.appendChild(selectValue);
                    if (index < this.selectedOptions.length - 1) {
                        (_b = this.selectValueRef) === null || _b === void 0 ? void 0 : _b.appendChild(global.document.createTextNode(', '));
                    }
                });
            }
            if (this.selectValueRef) {
                this.element.prepend(this.selectValueRef);
            }
        };
        this.appearance = undefined;
        this.autofocus = undefined;
        this.clearable = undefined;
        this.clearAriaLabel = undefined;
        this.disabled = undefined;
        this.helpText = undefined;
        this.invalid = false;
        this.label = undefined;
        this.multiple = false;
        this.name = undefined;
        this.optionalLabel = undefined;
        this.placeholder = undefined;
        this.required = false;
        this.requiredLabel = undefined;
        this.validationMessage = undefined;
        this.value = undefined;
        this.activeOptionElement = undefined;
        this.activeOptionIndex = 0;
        this.computedAppearance = 'dark';
        this.inputInvalid = false;
        this.isListBoxVisible = false;
        this.selectedOptions = [];
    }
    handleInvalidChange(newValue) {
        this.inputInvalid = newValue;
    }
    handleValueChange(newValue) {
        const option = this.options.find((option) => option.value === newValue);
        this.selectOption(option, false);
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
        this.options.forEach((el) => (el.appearance = this.computedAppearance));
        this.optgroups.forEach((el) => (el.appearance = this.computedAppearance));
    }
    handleSelectedOptionsChange() {
        this.updateSelectValueSlot();
    }
    /**
     * Removes focus from the Input.
     */
    async inputBlur() {
        this.comboBoxElement && this.comboBoxElement.blur();
    }
    /**
     * Sets focus on the Input. This will scroll the element into the view and focus it.
     */
    async inputFocus() {
        this.comboBoxElement && this.comboBoxElement.focus();
    }
    /**
     * Returns the validity status of the Input.
     * Fires an `inputinvalid` event in the case of invalidity.
     */
    async inputCheckValidity() {
        return this.checkValidity();
    }
    /**
     * Performs the same validity checking steps as the inputCheckValidity methods.
     * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
     */
    async inputReportValidity() {
        return this.reportValidity();
    }
    handleOptionSelect(event) {
        this.selectOption(event.target);
        if (!this.multiple) {
            this.closeListBox();
        }
    }
    handleKeyDown(event) {
        this.handleSelectKeyDown(event);
    }
    async closeListBox(resetFocus = true) {
        var _a;
        if (!this.isListBoxVisible)
            return;
        this.isListBoxVisible = false;
        this.isNavigatedWithKeyboard = false;
        (_a = this.tippyInstance) === null || _a === void 0 ? void 0 : _a.hide();
        global.window.removeEventListener('click', this.handleDocumentClick);
        if (resetFocus) {
            await forceFocus(this.comboBoxElement);
        }
    }
    openListBox() {
        var _a;
        this.isListBoxVisible = true;
        (_a = this.tippyInstance) === null || _a === void 0 ? void 0 : _a.show();
        global.window.addEventListener('click', this.handleDocumentClick);
    }
    checkValidity() {
        return !(this.required && !this.selectedOptions.length);
    }
    reportValidity() {
        this.inputInvalid = !this.checkValidity();
        if (this.inputInvalid) {
            this.inputinvalidEvent.emit();
        }
        return this.inputInvalid;
    }
    initAutofocus() {
        const isFirstAutofocusElementonPage = global.document.querySelector('[autofocus]') === this.element;
        if (isFirstAutofocusElementonPage) {
            setTimeout(async () => {
                await this.inputFocus();
            }, 1);
        }
    }
    isInvalidStateControlled() {
        return this.invalid;
    }
    selectOption(optionElement, shouldEmitEvent = true) {
        if (!optionElement || optionElement.disabled || this.isUpdatingOptions) {
            return;
        }
        this.multiple
            ? this.updateMultipleSelection(optionElement, shouldEmitEvent)
            : this.updateSingleSelection(optionElement, shouldEmitEvent);
        this.updateOptions();
    }
    updateSingleSelection(optionElement, shouldEmitEvent) {
        if (this.selectedOptions.includes(optionElement)) {
            return;
        }
        this.selectedOptions = [optionElement];
        this.value = optionElement.value;
        if (shouldEmitEvent) {
            this.handleSelectChange(this.value);
        }
    }
    updateMultipleSelection(optionElement, shouldEmitEvent) {
        if (this.selectedOptions.includes(optionElement)) {
            this.selectedOptions = this.selectedOptions.filter((option) => option !== optionElement);
        }
        else {
            this.selectedOptions = [...this.selectedOptions, optionElement];
        }
        this.value = this.selectedOptions.map((option) => option.value);
        if (shouldEmitEvent) {
            this.handleSelectChange(this.value);
        }
    }
    activateOption(optionElement) {
        if (optionElement) {
            this.activeOptionIndex = this.options.findIndex((item) => item === optionElement);
            this.activeOptionElement = optionElement;
            this.updateOptions();
        }
    }
    activateMatchingOption(searchTerm) {
        const matchingOption = this.getOptionBySearchTerm(searchTerm);
        if (matchingOption) {
            this.activateOption(matchingOption);
        }
        else {
            this.clearSearchTerm();
        }
    }
    getOptionBySearchTerm(searchTerm) {
        const filteredOptions = this.options.filter((option) => { var _a; return (_a = option.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(searchTerm.toLowerCase()); });
        const directMatch = filteredOptions[0];
        const allSameCharacter = searchTerm.split('').every((char) => char === searchTerm[0]);
        if (directMatch) {
            return directMatch;
        }
        /**
         * When all characters of the search term are the same (e.g. `bbb`)
         * we cycle through options that start with `b`
         */
        if (allSameCharacter) {
            // cycling through options by reordering them based on the current active option
            const orderedOptions = [
                ...this.options.slice(this.activeOptionIndex + 1),
                ...this.options.slice(0, this.activeOptionIndex + 1),
            ];
            const filteredOptions = orderedOptions.filter((option) => { var _a; return (_a = option.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(searchTerm[0].toLowerCase()); });
            return filteredOptions[0];
        }
    }
    getSearchTerm(key) {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.clearSearchTerm(), 500);
        this.searchTerm += key;
        return this.searchTerm;
    }
    clearSearchTerm() {
        this.searchTerm = '';
    }
    async clearSelect() {
        await forceFocus(this.comboBoxElement);
        this.activeOptionIndex = 0;
        this.selectedOptions = [];
        this.activeOptionElement = undefined;
        if (this.multiple) {
            this.value = [];
        }
        else {
            this.value = '';
        }
        this.inputchangeEvent.emit({ value: this.value });
        this.updateOptions();
    }
    getActionFromCode(code, key, ctrlKey, altKey, metaKey) {
        // when open or closed
        if (code === 'Home') {
            return this.selectActions.FIRST;
        }
        if (code === 'End') {
            return this.selectActions.LAST;
        }
        if (code === 'Backspace' ||
            code === 'Clear' ||
            (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)) {
            return this.selectActions.TYPE;
        }
        // when closed
        if (!this.isListBoxVisible) {
            if (['ArrowDown', 'Enter', 'Space'].includes(code)) {
                return this.selectActions.OPEN;
            }
            if (code === 'ArrowUp') {
                return this.selectActions.FIRST;
            }
        }
        // when open
        if (this.isListBoxVisible) {
            if (code === 'Tab') {
                return this.selectActions.CLOSE_SELECT;
            }
            if (code === 'Escape') {
                return this.selectActions.CLOSE;
            }
            if (code === 'PageDown') {
                return this.selectActions.PAGE_DOWN;
            }
            if (code === 'PageUp') {
                return this.selectActions.PAGE_UP;
            }
            if (code === 'ArrowUp' && altKey) {
                return this.selectActions.CLOSE_SELECT;
            }
            if (code === 'ArrowUp') {
                return this.selectActions.PREV;
            }
            if (code === 'ArrowDown' && !altKey) {
                return this.selectActions.NEXT;
            }
            if (code === 'Enter' || code === 'Space') {
                return this.selectActions.CLOSE_SELECT;
            }
        }
    }
    initTippy() {
        if (this.inputElement && this.listBoxElement) {
            const listBoxElement = this.listBoxElement;
            this.tippyInstance = tippy(this.inputElement, {
                appendTo: 'parent',
                trigger: 'manual',
                placement: 'bottom',
                hideOnClick: false,
                showOnCreate: true,
                offset: [0, 8],
                aria: {
                    content: null,
                    expanded: false,
                },
                interactive: true,
                popperOptions: {
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['top', 'bottom'],
                            },
                        },
                    ],
                },
                render() {
                    return {
                        popper: listBoxElement,
                    };
                },
            });
            this.tippyInstance.hide();
        }
    }
    initOptions() {
        this.options = Array.from(this.element.querySelectorAll(`${transformTagName('cosmos-option')}`));
        this.optgroups = Array.from(this.element.querySelectorAll(`${transformTagName('cosmos-optgroup')}`));
        this.multiple ? this.initMultipleSelection() : this.initSingleSelection();
        this.updateOptions();
    }
    initMultipleSelection() {
        const preSelectedOptions = this.getPreSelectedOptions();
        this.selectedOptions = preSelectedOptions;
        this.value = preSelectedOptions.map((option) => option.value);
    }
    initSingleSelection() {
        const preSelectedOption = this.getPreSelectedOption();
        if (preSelectedOption) {
            this.selectOption(preSelectedOption, false);
        }
    }
    updateOptions() {
        this.isUpdatingOptions = true; // Prevent updating options while iterating over them due to `optionselect` event
        this.options.forEach((option, index) => {
            // Set tabIndex to -1 for all options to manage focus dynamically when using keyboard navigation.
            // When not using keyboard, set tabIndex to 0 to ensure all options are still accessible to AT.
            option.tabIndex = this.isNavigatedWithKeyboard ? -1 : 0;
            if (this.selectedOptions.includes(option)) {
                option.setAttribute('selected', '');
            }
            else {
                option.removeAttribute('selected');
            }
            if (index === this.activeOptionIndex) {
                option.tabIndex = 0;
                option.focus();
            }
        });
        this.isUpdatingOptions = false;
    }
    connectedCallback() {
        this.form = this.element.closest('form');
        if (this.form) {
            this.form.addEventListener('formdata', this.handleFormData, true);
            this.form.addEventListener('submit', this.handleFormSubmit, true);
        }
    }
    disconnectedCallback() {
        if (this.form) {
            this.form.removeEventListener('formdata', this.handleFormData);
            this.form.removeEventListener('submit', this.handleFormSubmit);
        }
        global.window.removeEventListener('click', this.handleDocumentClick);
    }
    async componentWillLoad() {
        this.inputInvalid = this.invalid;
        await nextTick();
        this.initOptions();
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    componentDidLoad() {
        this.initTippy();
        if (this.autofocus) {
            this.initAutofocus();
        }
    }
    render() {
        return (h("div", { key: 'c885169a45af27a2480b389dc9611554b9a96f79', class: generateClassNames({ multiple: this.selectedOptions.length > 1 }), part: "base" }, h(FormField, { key: 'b8ac86ef3bb6f7dab7777d169a403a40d2d09fc4', element: this.element, appearance: this.computedAppearance, label: this.label, helpText: this.helpText, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, disabled: this.disabled, invalid: this.inputInvalid, validationMessage: this.getValidationMessage(), validationMessageRef: (el) => (this.validationMessageRef = el), labelForValue: "combobox", required: this.required }, h("div", { key: '90fcc159afa2b6550c741cee3600d0e04b49b55e', class: generateClassNames('input', {
                appearance: this.computedAppearance,
                placeholder: !this.selectedOptions.length,
                disabled: this.disabled,
                invalid: this.inputInvalid,
            }), onClick: this.handleSelectClick, ref: (el) => {
                this.inputElement = el;
            }, part: "select" }, h("div", { key: '75ccd5f0238e8ad2a3d68faf5db50c27960511eb', class: generateClassNames('combobox'), tabIndex: this.disabled ? -1 : 0, id: "combobox", role: "combobox", "aria-haspopup": "listbox", "aria-controls": this.tippyInstance && `tippy-${this.tippyInstance.id}`, "aria-expanded": getAriaExpanded(this.isListBoxVisible), "aria-disabled": getAriaDisabled(this.disabled), "aria-required": getAriaRequired(this.required), "aria-invalid": getAriaInvalid(this.inputInvalid), "aria-labelledby": "label", "aria-describedby": getAriaDescribedBy(this.inputInvalid), ref: (el) => {
                this.comboBoxElement = el;
            } }, this.selectedOptions.length > 0 && (h("span", { class: generateClassNames('sr-value') }, this.selectedOptions.map((option) => { var _a; return (_a = option.textContent) === null || _a === void 0 ? void 0 : _a.trim(); }).join(', '))), h("slot", { key: '47d6fde36c254fb67236edb441fe356de03c727f', name: "value", "aria-hidden": "true" }, h("cosmos-text", { key: 'df3825460e1f1b1e0e048727062cd6fe88a1e797', appearance: this.computedAppearance, clamp: 1, class: generateClassNames('placeholder'), kind: "subtle", size: "small" }, this.placeholder))), h("div", { key: '5a629f9dc771147b142c6eac005b29599d671b14', class: generateClassNames('focus-ring') }), !!this.clearable && !!this.selectedOptions.length && (h("cosmos-button", { "aria-label": this.clearAriaLabel, "aria-hidden": !this.clearAriaLabel, appearance: this.computedAppearance, class: generateClassNames('clearable-button'), kind: "tertiary", onClick: this.handleClearableClick, onKeyDown: this.handleClearableKeyDown, onMouseDown: (e) => e.preventDefault(), shape: "circle", size: "small" }, h("cosmos-icon-close", { slot: "icon" }))), h("cosmos-icon-chevron-down", { key: 'd0f0abb73a6b9017b8277399de27040905b405e9', class: generateClassNames('icon') })), h("div", { key: 'aea9c813ab873365c720a8b5a28dedaeb0e9b341', "aria-multiselectable": this.multiple ? 'true' : null, onClick: this.handleListBoxClick, role: "listbox", tabIndex: -1, part: "options", class: generateClassNames('listbox', {
                appearance: this.computedAppearance,
                open: this.isListBoxVisible,
            }), ref: (el) => {
                this.listBoxElement = el;
            } }, h("slot", { key: '90c2d52a2b7231497e49d57288a320e9351bec02' })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "invalid": ["handleInvalidChange"],
        "value": ["handleValueChange"],
        "appearance": ["handleAppearanceChange"],
        "selectedOptions": ["handleSelectedOptionsChange"]
    }; }
    static get style() { return CosmosSelectStyle0; }
}, [1, "cosmos-select", {
        "appearance": [513],
        "autofocus": [516],
        "clearable": [516],
        "clearAriaLabel": [513, "clear-aria-label"],
        "disabled": [516],
        "helpText": [513, "help-text"],
        "invalid": [516],
        "label": [513],
        "multiple": [516],
        "name": [513],
        "optionalLabel": [513, "optional-label"],
        "placeholder": [513],
        "required": [516],
        "requiredLabel": [513, "required-label"],
        "validationMessage": [513, "validation-message"],
        "value": [1537],
        "activeOptionElement": [32],
        "activeOptionIndex": [32],
        "computedAppearance": [32],
        "inputInvalid": [32],
        "isListBoxVisible": [32],
        "selectedOptions": [32],
        "inputBlur": [64],
        "inputFocus": [64],
        "inputCheckValidity": [64],
        "inputReportValidity": [64]
    }, [[0, "optionselect", "handleOptionSelect"], [0, "keydown", "handleKeyDown"]], {
        "invalid": ["handleInvalidChange"],
        "value": ["handleValueChange"],
        "appearance": ["handleAppearanceChange"],
        "selectedOptions": ["handleSelectedOptionsChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select", "cosmos-button", "cosmos-icon-chevron-down", "cosmos-icon-close", "cosmos-icon-warning", "cosmos-select-value", "cosmos-spinner", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelect$1);
            }
            break;
        case "cosmos-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "cosmos-icon-chevron-down":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "cosmos-icon-close":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-spinner":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosSelect = CosmosSelect$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosSelect, defineCustomElement };
